import React from 'react';
import { Button } from './Button';
import { Star, ShieldCheck, Zap, Download } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section className="py-20 px-4 bg-[#0A1628] relative" id="precio-lanzamiento" data-id="element-258">
      <div className="max-w-3xl mx-auto" data-id="element-259">
        <CountdownTimer data-id="element-260" />

        <div className="text-center mb-10" data-id="element-261">
          <h2 className="text-4xl md:text-5xl font-anton text-white mb-4" data-id="element-262">
            Elegí tu Megapack Resuelto:
          </h2>
          <p className="text-gray-400" data-id="element-263">
            Asegurá tu acceso con el precio de lanzamiento
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-264">
          {/* Single Prominent Offer */}
          <div className="rounded-2xl p-6 md:p-8 border-2 transition-all flex flex-col sm:flex-row sm:items-center gap-4 relative bg-gradient-to-r from-[#0F1F3D] to-[#1a2f52] border-[#C6F432] shadow-[0_0_30px_rgba(198,244,50,0.2)]" data-id="element-265">
            <div className="absolute -top-3 left-6 bg-[#C6F432] text-[#0A1628] text-[10px] md:text-xs font-black px-3 py-1 rounded-full flex items-center gap-1 shadow-md uppercase tracking-wider" data-id="element-266">
              <Star size={12} className="fill-[#0A1628]" data-id="element-267" /> MÁS ELEGIDO
            </div>

            <div className="flex items-start sm:items-center gap-4 w-full sm:w-auto flex-1 mt-2 sm:mt-0" data-id="element-268">
              <div className="flex-1" data-id="element-269">
                <h3 className="text-[#C6F432] font-bold text-xl md:text-2xl flex items-center gap-2 mb-1" data-id="element-270">
                  📘 MEGAPACK PADEL RESUELTO
                </h3>
                <p className="text-gray-300 text-sm md:text-base font-medium" data-id="element-271">
                  6 Módulos + 6 Bonos
                </p>
              </div>
            </div>
            <div className="text-left sm:text-right mt-4 sm:mt-0" data-id="element-272">
              <p className="text-gray-500 line-through text-sm md:text-base font-bold" data-id="element-273">
                $59.990
              </p>
              <p className="text-4xl md:text-5xl font-anton text-[#C6F432]" data-id="element-274">
                $20.990
              </p>
            </div>
          </div>
        </div>

        <Button checkout className="w-full text-lg md:text-xl py-5 animate-pulse shadow-[0_0_30px_rgba(198,244,50,0.3)]" data-id="element-275">
          👉 QUIERO MI MEGAPACK PADEL RESUELTO
        </Button>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-6 text-xs text-gray-400" data-id="element-276">
          <span className="flex items-center gap-1.5" data-id="element-277">
            <ShieldCheck size={16} className="text-[#C6F432]" data-id="element-278" /> Pago Seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-279">
            <Zap size={16} className="text-[#C6F432]" data-id="element-280" /> Acceso Inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-281">
            <Download size={16} className="text-[#C6F432]" data-id="element-282" /> PDF Digital
          </span>
        </div>
      </div>
    </section>;
}